"use client"

import React from "react"
import { Message } from "@locmod/intl"

import { Icon, type IconName } from "components/ui"
import { Href } from "components/navigation"
import messages from "./messages"

export const OverTimeSportSkeleton: React.FC<{
  children?: React.ReactNode
}> = ({ children }) => {
  return (
    <div>
      <div className="flex items-center justify-between py-3 px-4">
        <div className="flex items-center">
          <div className="bone size-6 mr-3 rounded-full" />
          <div className="bone h-6 w-20 rounded-md" />
        </div>
      </div>
      <div>{children}</div>
    </div>
  )
}

type OverTimeSportProps = {
  sport: any
  isPage?: boolean
  withLink?: boolean
  children?: React.ReactNode
}

const OverTimeSport: React.FC<OverTimeSportProps> = ({
  children,
  sport,
  isPage = false,
  withLink = true,
}) => {
  let { slug, name } = sport

  return (
    <div>
      <div className="flex items-center justify-between py-3 px-4">
        {isPage ? (
          <Message
            className="text-heading-h4 font-semibold"
            value={{ ...messages.sport, values: { sportName: name } }}
          />
        ) : (
          <div className="flex items-center">
            <Icon
              className="size-6 mr-3 text-brand-light-500"
              name={`sport/${slug}` as IconName}
            />
            <div className="text-heading-h4 font-semibold">{name}</div>
          </div>
        )}
        {Boolean(withLink && !isPage) && (
          <Href
            to={`/${slug}`}
            className="bg-accent-grey-1000 rounded-full text-accent-grey-200 hover:text-accent-grey-30 border border-accent-grey-850 size-6 flex items-center justify-center"
          >
            <Icon className="size-4" name="interface/chevron_right" />
          </Href>
        )}
      </div>
      <div>{children}</div>
    </div>
  )
}

export default OverTimeSport
